import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { IsRunningOverwolf } from "../utilityFunctions";
import { SendChangeLanguage } from "../overwolf/helper/windowCommunicationHelper";

interface LanguageSelectorPropsInterface {
  buttonScale?: string;
}

export const LanguageSelector: React.FC<LanguageSelectorPropsInterface> = ({
  buttonScale,
}) => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(
    i18n.language.split("-")[0].toUpperCase()
  );
  const dropdownRef = useRef<HTMLDivElement>(null);

  const languages = [
    { code: "en", label: "EN" },
    { code: "fr", label: "FR" },
  ];

  const handleLanguageChange = (lang: string) => {
    setSelected(lang.toUpperCase());
    i18n.changeLanguage(lang);
    setOpen(false);
    if (IsRunningOverwolf()) {
      SendChangeLanguage(lang);
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div ref={dropdownRef} className="relative inline-block text-left">
      <button
        onClick={() => setOpen(!open)}
        className={`text-slate-300 bg-transparent cursor-pointer text-lg md:text-sm w-12 2xl:w-11 flex items-center justify-between ${
          buttonScale ? buttonScale : "scale-110 2xl:scale-125"
        }`}
      >
        {selected}
        <svg
          className="ml-1 w-3 h-3 text-slate-300"
          viewBox="0 0 10 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1 1L5 5L9 1" stroke="currentColor" strokeWidth="1.5" />
        </svg>
      </button>

      {open && (
        <ul className="absolute mt-2 -right-4 md:-right-2 w-20 md:w-16 bg-slate-800 shadow-lg z-50 rounded-lg overflow-hidden">
          {languages.map((lang) => (
            <li
              key={lang.code}
              className="px-3 py-1 hover:bg-slate-700 text-slate-200 text-lg md:text-base cursor-pointer"
              onClick={() => handleLanguageChange(lang.code)}
            >
              {lang.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};
